import React from 'react'
import '../stylings/footer.css'
import logo from '../assest/logo1.jpg'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <footer className="site-footer">

            {/* ── CTA Band ── */}
            <div className="footer-cta-band">
                <div className="container">
                    <div className="footer-cta-inner">
                        <div className="footer-cta-text">
                            <h3>Admissions Open for 2026–2027</h3>
                            <p>Secure your child's future at Vidya Jain Convent School. Limited seats available.</p>
                        </div>
                        <div className="footer-cta-actions">
                            <Link to="/admission_form.pdf" target="_blank" className="footer-cta-btn footer-cta-btn--primary">
                                <i className="fa-solid fa-file-arrow-down"></i> Download Form
                            </Link>
                            <Link to="/contact" className="footer-cta-btn footer-cta-btn--ghost">
                                <i className="fa-solid fa-phone"></i> Contact Us
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Main body ── */}
            <div className="footer-body">
                <div className="container">
                    <div className="footer-grid">

                        {/* Brand */}
                        <div className="footer-col footer-col--brand">
                            <Link to="/">
                                <img src={logo} alt="Vidya Jain Convent School" className="footer-logo" />
                            </Link>
                            <p className="footer-about">
                                Nurturing excellence, character and lifelong learning. Providing quality CBSE education
                                to empower every child with knowledge, values and skills for tomorrow.
                            </p>

                            {/* affiliation badge */}
                            <div className="footer-affil">
                                <span className="footer-affil-icon"><i className="fa-solid fa-award"></i></span>
                                <div>
                                    <div className="footer-affil-label">CBSE Affiliated</div>
                                    <div className="footer-affil-no">Affiliation No: 2730922</div>
                                </div>
                            </div>

                            {/* social icons */}
                            <div className="footer-social">
                                <Link to="https://www.instagram.com/vjconventschool/" target="_blank" aria-label="Instagram" className="fs-ig">
                                    <i className="fa-brands fa-instagram"></i>
                                </Link>
                                <Link to="https://www.youtube.com/@vjconventschool515" target="_blank" aria-label="YouTube" className="fs-yt">
                                    <i className="fa-brands fa-youtube"></i>
                                </Link>
                                <Link to="https://www.facebook.com/vjconvent/" target="_blank" aria-label="Facebook" className="fs-fb">
                                    <i className="fa-brands fa-facebook-f"></i>
                                </Link>
                                <Link to="https://wa.me/919999740333" target="_blank" aria-label="WhatsApp" className="fs-wa">
                                    <i className="fa-brands fa-whatsapp"></i>
                                </Link>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="footer-col">
                            <h4 className="footer-col-title">
                                <span className="footer-col-title-bar"></span>
                                Quick Links
                            </h4>
                            <ul className="footer-links">
                                <li><Link to="/"><i className="fa-solid fa-house"></i>Home</Link></li>
                                <li><Link to="/about-school"><i className="fa-solid fa-school"></i>About School</Link></li>
                                <li><Link to="/galleryall"><i className="fa-solid fa-images"></i>Photo Gallery</Link></li>
                                <li><Link to="/videoall"><i className="fa-solid fa-film"></i>Video Gallery</Link></li>
                                <li><Link to="/public-disclosure"><i className="fa-solid fa-file-lines"></i>Public Disclosure</Link></li>
                                <li><Link to="/contact"><i className="fa-solid fa-phone"></i>Contact Us</Link></li>
                            </ul>
                        </div>

                        {/* Useful Links */}
                        <div className="footer-col">
                            <h4 className="footer-col-title">
                                <span className="footer-col-title-bar"></span>
                                Useful Links
                            </h4>
                            <ul className="footer-links">
                                <li><Link to="https://scstwelfare.delhi.gov.in/" target="_blank"><i className="fa-solid fa-hand-holding-heart"></i>SC/ST/OBC Scholarship</Link></li>
                                <li><Link to="https://www.minorityaffairs.gov.in/" target="_blank"><i className="fa-solid fa-star-and-crescent"></i>Minority Scholarship</Link></li>
                                <li><Link to="https://scholarships.gov.in/" target="_blank"><i className="fa-solid fa-graduation-cap"></i>National Scholarship</Link></li>
                                <li><Link to="https://www.cbse.gov.in/" target="_blank"><i className="fa-solid fa-landmark"></i>CBSE Official Site</Link></li>
                                <li><Link to="/noticeall"><i className="fa-solid fa-bell"></i>Notice Board</Link></li>
                                <li><Link to="/academic-calender"><i className="fa-solid fa-calendar-check"></i>Academic Calendar</Link></li>
                            </ul>
                        </div>

                        {/* Contact */}
                        <div className="footer-col">
                            <h4 className="footer-col-title">
                                <span className="footer-col-title-bar"></span>
                                Get in Touch
                            </h4>

                            <div className="footer-contact-card">
                                <Link to="https://maps.app.goo.gl/S9eiJ715eFjEyEvp6" target="_blank" className="fcc-item">
                                    <span className="fcc-icon"><i className="fa-solid fa-location-dot"></i></span>
                                    <span className="fcc-text">
                                        <strong>Address</strong>
                                        Khasra No. 142, Plot 289,<br />Delhi – 110081
                                    </span>
                                </Link>
                                <Link to="tel:+919999740333" className="fcc-item">
                                    <span className="fcc-icon"><i className="fa-solid fa-phone-volume"></i></span>
                                    <span className="fcc-text">
                                        <strong>Phone</strong>
                                        +91 9999740333
                                    </span>
                                </Link>
                                <Link to="mailto:vjconvent2004@gmail.com" className="fcc-item">
                                    <span className="fcc-icon"><i className="fa-solid fa-envelope"></i></span>
                                    <span className="fcc-text">
                                        <strong>Email</strong>
                                        vjconvent2004@gmail.com
                                    </span>
                                </Link>
                                <div className="fcc-item fcc-item--time">
                                    <span className="fcc-icon"><i className="fa-solid fa-clock"></i></span>
                                    <span className="fcc-text">
                                        <strong>School Hours</strong>
                                        Mon – Sat &nbsp;|&nbsp; 8:00 AM – 2:30 PM
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ── Bottom bar ── */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-inner">
                        <p className="footer-copy">
                            &copy; 2026 <strong>Vidya Jain Convent School</strong>. All rights reserved.
                        </p>
                        <p className="footer-dev">
                            Designed &amp; Developed by{' '}
                            <Link to="http://www.mycampus.co.in/" target="_blank" rel="noopener noreferrer">
                                myCampus Technology
                            </Link>
                        </p>
                    </div>
                </div>
            </div>

        </footer>
    )
}

export default Footer
